import React from "react";
import "../Styles/About.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faSquareGithub } from "@fortawesome/free-brands-svg-icons";

function About() {
  return (
    <div className="About">
      <div className="title">About</div>
      <div className="text">
      Hi, I'm Riana! I'm a big fan of coding from
        scratch (in a non-pretentious way) and bringing interactive digital experiences to fruition.
        
        <br /><br />
        I graduated from NYU with a B.A. in Mathematics, which has shaped my analytical
        thinking and problem-solving abilities.  
        <br /><br />
         I'm a curiousity-driven developer passionate about creating user
        interfaces that combine thoughtful design with engineering.
        
        
      <div className="social-links">
        <div>
        <a href="https://github.com/r-shahid/">
              <FontAwesomeIcon icon={faSquareGithub} />
            </a>
        </div>
        <div>
        <a href="https://www.linkedin.com/in/rianashahid/">
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
        </div>
        {/* <div>
          Twitter
        </div> */}
      </div>
      </div>
      
    </div>
  );
}

export default About;
